import { Radio } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './ToStoreOrderDetail.less';

export default class ToStoreOrderDetail extends OfficialPage {
  state = {
    orderInfo: {},
    orderStatus: [
      '待付款',
      '待商家确认',
      '商家已确认',
      '待评价',
      '退款审核中',
      '退款中',
      '已完成',
      '已关闭'
    ],
    addressList: [],
    selectAddressId: '',
    addressDialogHidden: true,
    goodsAdditionalInfo: {},
    hasAdditionalInfo: false,
    customFields: [],
    isFromBack: false,
    orderId: '',
    isFromTemplateMsg: false,
    discountList: '',
    toStoreInfo: {},
    originalPrice: '',
    balance: '',
    useBalance: '',
    freghtSwitch: '',
    delivery: '',
    express_fee: '',
    refund: false,
    applyRefund: false,
    refundType: 0,
    refundMoneyType: 0,
    withdrawRefund: false
  }

  constructor(props) {
    super(props);
    document.title = '订单详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      orderId: options.detail,
      isFromTemplateMsg: options.from === 'template_msg' ? true : false,
      franchiseeId: options.franchisee || ''
    })
    this.dataInitial()
  }

  dataInitial = () => {
    this.getOrderDetail(this.data.orderId)
    this.GetTostoreWaitingRule()
  }

  componentDidMount() {
    if (this.data.isFromBack) {
      if (!!this.data.orderInfo.order_id) {
        this.getOrderDetail(this.data.orderInfo.order_id, 1)
      }
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  getOrderDetail = (orderId, isFromAddrSelect) => {
    var that = this
    app.getOrderDetail({
      data: {
        order_id: orderId,
        sub_shop_app_id: that.data.franchiseeId
      },
      success: function (res) {
        var form_data = res.data[0].form_data,
          hasAdditionalInfo = false,
          address_id = ''
        form_data.totalPay = form_data.total_price
        if (!isFromAddrSelect) {
          for (var i = 0; i < form_data.goods_info.length; i++) {
            var deliveryId = form_data.goods_info[i].delivery_id
            if (deliveryId && deliveryId != '0') {
              that.getGoodsCustomField(i, deliveryId)
              hasAdditionalInfo = true
            }
          }
        }
        if (form_data.address_info && that.data.freghtSwitch) {
          address_id = form_data.address_info.address_id
          that.setData({
            selectAddressId: address_id
          })
        }
        if (form_data.tostore_data && form_data.tostore_data.appointed_time)
          form_data.tostore_data.format_appointed_time =
            form_data.tostore_data.appointed_time
        that.setData({
          orderInfo: form_data,
          discountList: form_data.selected_benefit,
          index: form_data.can_use_benefit.selected_index,
          hasAdditionalInfo: hasAdditionalInfo,
          toStoreInfo: form_data.tostore_data,
          benefitPrice: form_data.discount_cut_price,
          balance: Number(res.data[0]['balance']),
          useBalance: form_data['use_balance'],
          express_fee: res.data[0]['express_fee']
        })
      }
    })
  }
  orderDelete = e => {
    var orderId = this.data.orderId,
      that = this,
      franchiseeId = this.data.franchiseeId
    app.showModal({
      content: '订单删除后不可找回，确认删除？',
      showCancel: true,
      cancelText: '取消',
      confirmText: '确定',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/HideOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: franchiseeId
          },
          success: function (res) {
            app.turnBack()
          }
        })
      }
    })
  }
  getGoodsCustomField = (goodsIndex, deliveryId) => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=pc/AppShop/GetDelivery',
      data: {
        app_id: app.getAppId(),
        delivery_id: deliveryId
      },
      success: function (res) {
        var deliveryInfo = res.data.delivery_info,
          goodsId = that.data.orderInfo.goods_info[goodsIndex].goods_id,
          data = {},
          fields = []
        data['goodsAdditionalInfo.' + goodsId + ''] = deliveryInfo
        for (var i = 0; i < deliveryInfo.length; i++) {
          var info = {}
          info.type = deliveryInfo[i].type
          info.title = deliveryInfo[i].name
          fields.push(info)
        }
        data['customFields[' + goodsIndex + ']'] = fields
        that.setData(data)
      }
    })
  }
  customFieldInput = e => {
    var dataset = e.currentTarget.dataset,
      goodsIndex = dataset.goodsIndex,
      fieldIndex = dataset.fieldIndex,
      value = e.target.value,
      data = {}
    data['customFields[' + goodsIndex + '][' + fieldIndex + '].value'] = value
    this.setData(data)
  }
  uploadCustomFieldImage = e => {
    var that = this,
      dataset = e.currentTarget.dataset,
      goodsIndex = dataset.goodsIndex,
      fieldIndex = dataset.fieldIndex,
      data = {}
    app.chooseImage(function (paths) {
      data['customFields[' + goodsIndex + '][' + fieldIndex + '].value'] = paths
      that.setData(data)
    }, 9)
  }
  deleteCustomFieldImage = e => {
    var dataset = e.currentTarget.dataset,
      goodsIndex = dataset.goodsIndex,
      fieldIndex = dataset.fieldIndex,
      imageArray = this.data.customFields[goodsIndex][fieldIndex].value,
      imageIndex = dataset.imageIndex,
      data = {}
    imageArray.splice(imageIndex, 1)
    data[
      'customFields[' + goodsIndex + '][' + fieldIndex + '].value'
    ] = imageArray
    this.setData(data)
  }
  sendDeliveryInfo = () => {
    var additional_info = {},
      goodsInfo = this.data.orderInfo.goods_info
    for (var i = 0; i < goodsInfo.length; i++) {
      additional_info[goodsInfo[i].goods_id] = this.data.customFields[i]
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/SetAdditional',
      method: 'POST',
      data: {
        order_id: this.data.orderInfo.order_id,
        additional_info: additional_info
      },
      success: function (res) { }
    })
  }
  cancelOrder = e => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.showModal({
      content: '是否取消订单？',
      showCancel: true,
      confirmText: '是',
      cancelText: '否',
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=AppShop/cancelOrder',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId
          },
          success: function (res) {
            var data = {}
            data['orderInfo.status'] = 7
            that.setData(data)
          }
        })
      }
    })
  }
  payOrder = e => {
    var address_info = this.data.orderInfo.address_info,
      that = this,
      orderId
    if (!address_info && this.data.orderInfo.goods_type != 3) {
      app.showModal({
        content: '请选择邮寄地址'
      })
      return
    }
    if (this.data.hasAdditionalInfo) {
      this.sendDeliveryInfo()
    }
    orderId = this.data.orderInfo.order_id
    if (this.data.orderInfo.totalPay == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function (res) {
          app.showToast({
            title: '支付成功',
            success: function () {
              that.paySuccessCallback()
            }
          })
        }
      })
      return
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      data: {
        order_id: orderId,
        sub_shop_app_id: that.data.franchiseeId
      },
      success: function (res) {
        var param = res.data,
          orderId = that.data.orderInfo.order_id
        param.orderId = orderId
        param.goodsType = that.data.orderInfo.goods_type
        param.success = function () {
          that.paySuccessCallback()
        }
        app.wxPay(param)
      }
    })
  }
  confirmRefund = e => {
    let type = this.data.refundType
    switch (+type) {
      case 0:
        this.applyDrawback()
        break
      case 1:
        this.sureReceipt()
        break
      case 2:
        this.withdrawRefund()
        break
      case 3:
        this.receiveDrawback()
        break
    }
  }
  applyDrawback = e => {
    var orderId = this.data.orderInfo.order_id,
      money = this.data.refundMoneyType == 0 ? '' : +this.data.refundMoney,
      that = this
    if (this.data.refundMoneyType != 0 && !this.data.refundMoney) {
      app.showModal({
        content: '请输入退款金额'
      })
      return
    }
    if (
      money &&
      !/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(money) &&
      money == 0
    ) {
      app.showModal({
        content: '请输入正确的金额'
      })
      return
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/applyRefund',
      data: {
        refund_price: money,
        order_id: orderId,
        sub_shop_app_id: that.data.franchiseeId
      },
      success: function (res) {
        var data = {}
        data['orderInfo.status'] = 4
        data['refund'] = false
        data['orderInfo.refund_info'] = {
          refund_fee: 0,
          refund_balance:
            +money || +that.data.orderInfo.totalPay + +that.data.useBalance
        }
        that.setData(data)
      }
    })
  }
  withdrawRefund = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/cancelRefund',
      data: {
        order_id: that.data.orderInfo.order_id,
        sub_shop_app_id: that.data.franchiseeId
      },
      success: function (res) {
        var data = {}
        data['orderInfo.status'] = +res.data
        data['refund'] = false
        data['refundMoney'] = ''
        data['orderInfo.refund_info'] = ''
        that.setData(data)
      }
    })
  }
  receiveDrawback = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/comfirmRefund',
      data: {
        order_id: orderId,
        sub_shop_app_id: that.data.franchiseeId
      },
      success: function (res) {
        that.getOrderDetail(that.data.orderId)
        that.setData({
          refund: false
        })
      }
    })
  }
  checkLogistics = () => {
    var orderId = this.data.orderInfo.order_id
    app.turnToPage(
      '/eCommerce/pages/logisticsPage/logisticsPage?detail=' + orderId
    )
  }
  sureReceipt = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/comfirmOrder',
      data: {
        order_id: orderId,
        sub_shop_app_id: that.data.franchiseeId
      },
      success: function (res) {
        var data = {}
        data['orderInfo.status'] = 3
        data['refund'] = false
        that.setData(data)
      }
    })
  }
  makeComment = () => {
    var franchiseeId = this.data.franchiseeId,
      pagePath =
        '/eCommerce/pages/makeComment/makeComment?detail=' +
        this.data.orderInfo.order_id +
        (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }
  previewImage = e => {
    app.previewImage({
      current: e.currentTarget.dataset.src
    })
  }
  goToHomepage = () => {
    var router = app.getHomepageRouter()
    app.turnToPage('/pages/' + router + '/' + router, true)
  }
  changeDiscount = e => {
    var _this = this
    var index = _this.data.orderInfo.can_use_benefit.selected_index
    var value = parseInt(e.target.value)
    this.setData({
      index: value
    })
    var discount_type =
      _this.data.orderInfo.can_use_benefit.data[value].discount_type,
      coupon_id = _this.data.orderInfo.can_use_benefit.data[value].coupon_id
    app.sendRequest({
      url: '/index.php?r=AppShop/ChangeOrder',
      data: {
        app_id: app.getAppId(),
        order_id: _this.data.orderInfo.order_id,
        discount_type: discount_type,
        coupon_id: coupon_id,
        sub_shop_app_id: _this.data.franchiseeId
      },
      success: function (res) {
        _this.getOrderDetail(res.data[0].form_data.order_id)
      }
    })
  }
  verificationCode = () => {
    app.turnToPage(
      '/eCommerce/pages/verificationCodePage/verificationCodePage?detail=' +
      this.data.orderInfo.order_id +
      '&sub_shop_app_id=' +
      this.data.franchiseeId
    )
  }
  changeRefundType = e => {
    this.setData({
      refundMoneyType: e.target.value
    })
  }
  refundMoney = e => {
    this.setData({
      refundMoney: e.target.value
    })
  }
  refund = e => {
    this.setData({
      refundMoney: '',
      refund: true,
      refundType: +e.currentTarget.dataset.type
    })
  }
  cancelRefund = () => {
    this.setData({
      refund: false
    })
  }
  customerConfirm = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/comfirmOrder',
      data: {
        order_id: this.data.orderInfo.order_id
      },
      success: function () {
        var data = {}
        data['orderInfo.status'] = 3
        that.setData(data)
      }
    })
  }
  isUseBalance = e => {
    var _this = this
    var isBalance = Number(e.target.value)
    app.sendRequest({
      url: '/index.php?r=AppShop/ChangeOrder',
      data: {
        app_id: app.getAppId(),
        order_id: _this.data.orderInfo.order_id,
        sub_shop_app_id: _this.data.franchiseeId,
        is_balance: isBalance
      },
      success: function (res) {
        _this.getOrderDetail(res.data[0].form_data.order_id)
      }
    })
  }
  paySuccessCallback = () => {
    let orderId = this.data.orderInfo.order_id
    let franchiseeId = this.data.franchiseeId
    let pagePath =
      '/orderMeal/pages/paySuccess/paySuccess?detail=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    if (!franchiseeId) {
      app.sendRequest({
        url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
        data: {
          order_id: orderId,
          sub_app_id: franchiseeId
        },
        success: function (res) {
          if (res.valid == 0) {
            pagePath += '&collectBenefit=1'
          }
          app.turnToPage(pagePath, 1)
        }
      })
    } else {
      app.turnToPage(pagePath, 1)
    }
  }
  GetTostoreWaitingRule = () => {
    let _this = this
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetTostoreWaitingRule',
      data: {
        sub_shop_app_id: _this.data.franchiseeId || ''
      },
      method: 'get',
      success: function (res) {
        _this.setData({
          shopInfo: res.data
        })
      }
    })
  }
  makeComment = () => {
    var franchiseeId = this.data.franchiseeId,
      pagePath =
        '/orderMeal/pages/makeTostoreComment/makeTostoreComment?detail=' +
        this.data.orderInfo.order_id +
        (franchiseeId ? '&franchisee=' + franchiseeId : '')
    app.turnToPage(pagePath)
  }

  render() {
    const {
      showGetUserInfo,
      isFromTemplateMsg,
      orderStatus,
      orderInfo,
      toStoreInfo,
      shopInfo,
      customFields,
      goodsAdditionalInfo,
      discountList,
      benefitPrice,
      useBalance,
      refund,
      refundType,
      refundMoneyType,
      refundMoney
    } = this.state

    return (
      <div className="official-page to-store-order-detail">
        <TopNav title="订单详情"/>
        <React.Fragment>
          <div className="orderDetail-wrap page" id="orderDetail">
            {isFromTemplateMsg && (
              <div
                className="orderDetail-section orderDetail-goto-homepage"
                onClick={this.goToHomepage}
                style={convertLineStyleData('margin-bottom:0;')}
              >
                <div className="ico-moon icon-rightarrow"></div>返回首页
              </div>
            )}
            <div className="orderDetail-section">
              <div style={convertLineStyleData('margin-bottom:4px;')}>
                <span style={convertLineStyleData('color:#888;')}>订单状态：</span>
                <span className="orderDetail-pay-count">
                  {orderStatus[orderInfo.status]}
                </span>
              </div>
              <div>
                <span style={convertLineStyleData('color:#888;')}>订单号：</span>
                {orderInfo.order_id}
              </div>
            </div>
            <div className="orderDetail-section">
              <div style={convertLineStyleData('margin-bottom:4px;')}>
                <span style={convertLineStyleData('color:#888;')}>排队号:</span>
                {toStoreInfo.formatted_queue_num}
              </div>
              <div>
                <span style={convertLineStyleData('color:#888;')}>到店时间:</span>
                {toStoreInfo.format_appointed_time}
              </div>
            </div>
            <div className="orderDetail-section">
              {orderInfo.location_name && (
                <div className="orderDetail-item-row">
                  <span style={convertLineStyleData('color:#888;')}>到店位置:</span>
                  <span>{orderInfo.location_name}</span>
                </div>
              )}
              <div className="orderDetail-item-row">
                <span style={convertLineStyleData('color:#888;')}>到店方式:</span>
                {toStoreInfo.tostore_order_type == 1 ? (
                  <span>{(shopInfo && shopInfo.tostore_type[0].name) || '点餐'}</span>
                ) : (
                    <span>
                      {((shopInfo && shopInfo.tostore_type[1].name) || '预约') +
                        ' ' +
                        toStoreInfo.tostore_appointment_time}
                    </span>
                  )}
              </div>
            </div>
            <div className="orderDetail-section">
              <div className="orderDetail-item-row">
                <span style={convertLineStyleData('color:#888;')}>手机号码:</span>
                <span>{toStoreInfo.tostore_buyer_phone}</span>
              </div>
              <div className="orderDetail-item-row">
                <span style={convertLineStyleData('color:#888;')}>备注信息:</span>
                <span>{toStoreInfo.tostore_remark || '无'}</span>
              </div>
            </div>
            <div className="orderDetail-section">
              <div className="orderDetail-order-list">
                {orderInfo.goods_info && orderInfo.goods_info.map((goods, goodsIndex) => {
                  return (
                    <React.Fragment key={goodsIndex}>
                      <div className="dialog-block-item">
                        <img
                          className="list-goods-cover"
                          src={goods.cover}
                        />
                        <div className="list-goods-content">
                          <div style={convertLineStyleData('overflow:hidden;white-space:nowrap;text-overflow:ellipsis;')}>
                            {goods.goods_name}
                          </div>
                          {goods.model_value && (
                            <div className="list-goods-model">
                              {goods.model_value}
                            </div>
                          )}
                          {goods.is_benefit_goods && (
                            <div className="gift-text">赠品</div>
                          )}
                        </div>
                        {!goods.is_benefit_goods ? (
                          <div className="list-goods-right">
                            <div className="orderDetail-pay-count">
                              {'¥' + goods.price}
                            </div>
                            <div>{'× ' + goods.num}</div>
                          </div>
                        ) : (
                            goods.is_benefit_goods && (
                              <div className="list-goods-right">
                                <div>× 1</div>
                              </div>
                            )
                          )}
                      </div>
                      {goodsAdditionalInfo[goods.goods_id] && (
                        <div className="dialog-block-item">
                          {goodsAdditionalInfo[goods.goods_id].map(
                            (field, fieldIndex) => {
                              return (
                                <div className="customField-container" key={fieldIndex}>
                                  {orderInfo.additional_info &&
                                    orderInfo.additional_info[goods.goods_id] ? (
                                      <React.Fragment>
                                        {field.type === 'text' ||
                                          field.type === 'mul-text' ? (
                                            <React.Fragment>
                                              <div>
                                                {field.name +
                                                  ':' +
                                                  orderInfo.additional_info[
                                                    goods.goods_id
                                                  ][fieldIndex].value}
                                              </div>
                                            </React.Fragment>
                                          ) : (
                                            field.type === 'picture' && (
                                              <React.Fragment>
                                                {orderInfo.additional_info[
                                                  goods.goods_id
                                                ][fieldIndex].value.map(
                                                  (imgUrl, index) => {
                                                    return (
                                                      <div
                                                        className="custom-field-image"
                                                        key={index}
                                                      >
                                                        <img
                                                          src={imgUrl}
                                                          mode="aspectFit"
                                                          onClick={this.previewImage}
                                                          data-src={imgUrl}
                                                        />
                                                      </div>
                                                    )
                                                  }
                                                )}
                                              </React.Fragment>
                                            )
                                          )}
                                      </React.Fragment>
                                    ) : (
                                      <React.Fragment>
                                        {field.type === 'text' ? (
                                          <React.Fragment>
                                            <input
                                              data-name={field.name}
                                              data-goods-index={goodsIndex}
                                              data-field-index={fieldIndex}
                                              placeholder={field.name}
                                              onInput={this.customFieldInput}
                                            />
                                          </React.Fragment>
                                        ) : field.type === 'mul-text' ? (
                                          <React.Fragment>
                                            <textarea
                                              data-name={field.name}
                                              data-goods-index={goodsIndex}
                                              data-field-index={fieldIndex}
                                              placeholder={field.name}
                                              onInput={this.customFieldInput}
                                            ></textarea>
                                          </React.Fragment>
                                        ) : (
                                              field.type === 'picture' && (
                                                <React.Fragment>
                                                  {customFields[goodsIndex][
                                                    fieldIndex
                                                  ].value.map(
                                                    (fieldImg, imageIndex) => {
                                                      return (
                                                        <div
                                                          className="custom-field-image"
                                                          key={imageIndex}
                                                        >
                                                          <img
                                                            src={fieldImg}
                                                            mode="aspectFit"
                                                            onClick={this.previewImage}
                                                            data-src={fieldImg}
                                                          />
                                                          <label
                                                            className="delete-img"
                                                            onClick={
                                                              this
                                                                .deleteCustomFieldImage
                                                            }
                                                            data-goods-index={
                                                              goodsIndex
                                                            }
                                                            data-field-index={
                                                              fieldIndex
                                                            }
                                                            data-image-index={
                                                              imageIndex
                                                            }
                                                          >
                                                            ×
                                                    </label>
                                                        </div>
                                                      )
                                                    }
                                                  )}
                                                  <div
                                                    className="upload-field-image"
                                                    onClick={
                                                      this.uploadCustomFieldImage
                                                    }
                                                    data-name={field.name}
                                                    data-goods-index={goodsIndex}
                                                    data-field-index={fieldIndex}
                                                  >
                                                    {field.name}
                                                  </div>
                                                </React.Fragment>
                                              )
                                            )}
                                      </React.Fragment>
                                    )}
                                </div>
                              )
                            }
                          )}
                        </div>
                      )}
                    </React.Fragment>
                  )
                })}
              </div>
              <div className="dialog-block-item">
                <div className="orderDetail-item-row">
                  <span style={convertLineStyleData('color:#888;')}>商品总额：</span>
                  <span className="pull-right">
                    {'¥' + orderInfo.original_price}
                  </span>
                </div>
                {!!+orderInfo.total_integral &&
                  orderInfo.total_integral != 0 &&
                  orderInfo.total_integral != '0' && (
                    <div className="orderDetail-item-row">
                      <span style={convertLineStyleData('color:#888;')}>订单积分：</span>
                      <span className="pull-right">
                        {orderInfo.total_integral + '积分'}
                      </span>
                    </div>
                  )}
                <div
                  className="orderDetail-item-row"
                  hidden={orderInfo.selected_benefit && orderInfo.selected_benefit.discount_type == null}
                >
                  <div>
                    <span style={convertLineStyleData('color:#888;')}>店铺优惠：</span>
                    <span style={convertLineStyleData('float:right;word-break:break-all;')}>
                      {discountList.title}
                    </span>
                  </div>
                </div>
                <div
                  className="orderDetail-item-row"
                  hidden={orderInfo.selected_benefit && orderInfo.selected_benefit.discount_type == null}
                >
                  <span style={convertLineStyleData('color:#888;')}>优惠抵扣：</span>
                  <span className="pull-right">{'- ¥' + benefitPrice}</span>
                </div>
                <div
                  className="orderDetail-item-row"
                  hidden={
                    orderInfo.extra_selected_benefit_info && orderInfo.extra_selected_benefit_info.discount_type == null
                  }
                >
                  <div>
                    <span style={convertLineStyleData('color:#888;')}>联盟优惠：</span>
                    <span style={convertLineStyleData('float:right;word-break:break-all;')}>
                      {orderInfo.extra_selected_benefit_info && orderInfo.extra_selected_benefit_info.title}
                    </span>
                  </div>
                </div>
                <div
                  className="orderDetail-item-row"
                  hidden={
                    orderInfo.extra_selected_benefit_info && orderInfo.extra_selected_benefit_info.discount_type == null
                  }
                >
                  <span style={convertLineStyleData('color:#888;')}>联盟优惠抵扣：</span>
                  <span className="pull-right">
                    {'- ¥' + orderInfo.extra_discount_cut_price}
                  </span>
                </div>
                <div
                  className="orderDetail-item-row"
                  hidden={orderInfo.status == 0}
                >
                  <span style={convertLineStyleData('color:#888;')}>储值抵扣：</span>
                  <span className="pull-right">{'- ¥' + useBalance}</span>
                </div>
                <div
                  className="orderDetail-item-row"
                  hidden={!orderInfo.coupon_fee}
                >
                  <span style={convertLineStyleData('color:#888;')}>社交立减金：</span>
                  <span className="pull-right">
                    {'- ¥' + orderInfo.coupon_fee}
                  </span>
                </div>
              </div>
              <div className="dialog-block-item">
                <div className="orderDetail-item-row">
                  <span style={convertLineStyleData('color:#888;')}>下单时间：</span>
                  <span className="pull-right">{orderInfo.add_time}</span>
                </div>
                <div className="orderDetail-item-row">
                  <span style={convertLineStyleData('color:#888;')}>实付价格：</span>
                  <span className="orderDetail-pay-count pull-right">
                    {'¥' + orderInfo.totalPay}
                  </span>
                </div>
                {orderInfo.refund_info && (
                  <div className="orderDetail-item-row">
                    <span style={convertLineStyleData('color:#888;')}>退款金额：</span>
                    <span className="pull-right">
                      {'¥' +
                        (orderInfo.refund_info.refund_fee +
                          orderInfo.refund_info.refund_balance)}
                    </span>
                  </div>
                )}
              </div>
              <div className="txt-c orderDetail-btn-status">
                {orderInfo.status == 0 && (
                  <React.Fragment>
                    <span
                      className="btn orderDetail-cancel-order"
                      onClick={this.cancelOrder}
                    >
                      取消订单
                    </span>
                    <span
                      className="btn btn-orange orderDetail-pay-directly"
                      onClick={this.payOrder}
                    >
                      立即支付
                    </span>
                  </React.Fragment>
                )}
                {orderInfo.status == 1 && (
                  <React.Fragment>
                    <span className="btn" onClick={this.refund} data-type="0">
                      申请退款
                    </span>
                  </React.Fragment>
                )}
                {orderInfo.status == 2 && (
                  <React.Fragment>
                    <span className="btn" onClick={this.refund} data-type="0">
                      申请退款
                    </span>
                    <span
                      className="btn btn-orange orderDetail-verification-code"
                      onClick={this.verificationCode}
                    >
                      核销码
                    </span>
                    {/*  <text class="btn btn-orange orderDetail-verification-code" bindtap="customerConfirm">确认</text>  */}
                    <span
                      className="btn btn-orange orderDetail-verification-code"
                      data-type="1"
                      onClick={this.refund}
                    >
                      确认已到店
                    </span>
                  </React.Fragment>
                )}
                {orderInfo.status == 3 && (
                  <React.Fragment>
                    <span
                      className="btn btn-orange orderDetail-verification-code"
                      onClick={this.makeComment}
                    >
                      评价
                    </span>
                  </React.Fragment>
                )}
                {orderInfo.status == 4 && (
                  <React.Fragment>
                    <span
                      className="btn btn-orange orderDetail-verification-code"
                      onClick={this.refund}
                      data-type="2"
                    >
                      撤销退款申请
                    </span>
                  </React.Fragment>
                )}
                {orderInfo.status == 5 && (
                  <React.Fragment>
                    <span
                      className="btn btn-orange orderDetail-verification-code"
                      onClick={this.refund}
                      data-type="3"
                    >
                      收到退款
                    </span>
                  </React.Fragment>
                )}
                {orderInfo.status == 6 && (
                  <React.Fragment>
                    <span
                      className="btn btn-orange myOrder-delete"
                      onClick={this.orderDelete}
                    >
                      刪除订单
                    </span>
                  </React.Fragment>
                )}
                {orderInfo.status == 7 && (
                  <React.Fragment>
                    <span
                      className="btn btn-orange myOrder-delete"
                      onClick={this.orderDelete}
                    >
                      刪除订单
                    </span>
                  </React.Fragment>
                )}
              </div>
            </div>
            <div className="applyRefund" hidden={!refund}>
              <div className="applyRefundMain">
                {refundType == 0 && (
                  <div className="refundTitle">确认退款金额</div>
                )}
                {refundType == 0 && (
                  <label style={convertLineStyleData('margin-top: 0;')}>
                    <Radio
                      value="0"
                      checked={refundMoneyType == 0}
                      color="#ff7100"
                      className="radio"
                      onChange={this.changeRefundType}></Radio>
                    <span className="radioText">全额退款</span>
                  </label>
                )}
                {refundType == 0 && (
                  <label>
                    <Radio
                      value="1"
                      checked={refundMoneyType != 0}
                      color="#ff7100"
                      className="radio"
                      onChange={this.changeRefundType}
                    ></Radio>
                    <span className="radioText">部分退款</span>
                    <input
                      onChange={() => {}}
                      onInput={this.refundMoney}
                      value={refundMoney}
                      type="text"
                      style={convertLineStyleData(
                        refundMoneyType == 0
                          ? 'display: none;'
                          : 'dispaly:inline-block;'
                      )}
                    />
                  </label>
                )}

                {refundType == 1 && (
                  <div style={convertLineStyleData('text-align:center;margin:20px 0 10px;font-size: 30rpx;')}>
                    提示
                  </div>
                )}
                {refundType == 1 && (
                  <div className="WithdrawRefundTitle-sec">
                    确认到店后订单完成，无法核销。请到店联系工作人员后确认！
                  </div>
                )}
                {refundType == 2 && (
                  <div className="WithdrawRefundTitle">确定撤销退款申请</div>
                )}
                {refundType == 3 && (
                  <div className="WithdrawRefundTitle">确定已收到退款</div>
                )}
                <div className="applyRefundBtn">
                  <span onClick={this.cancelRefund}>取消</span>
                  {refundType == 1 && (
                    <span
                      className="commitBtn"
                      data-refundtype={refundMoneyType}
                      onClick={this.confirmRefund}
                    >
                      我已到店
                    </span>
                  )}
                  {refundType != 1 && (
                    <span
                      className="commitBtn"
                      data-refundtype={refundMoneyType}
                      onClick={this.confirmRefund}
                    >
                      确认
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/to-store-order-detail/ToStoreOrderDetail.jsx